/**
 * Created by charnjeetelectrovese@gmail.com on 12/19/2019.
 */
import {formDataRequest, postRequest} from '../libs/AxiosService.util';

export async function serviceCreateBanner(params) {
    return await formDataRequest('banners/create', params);
}
export async function serviceUpdateBanner(params) {
    return await formDataRequest('banners/update', params);
}
export async function serviceDeleteBanner(params) {
    return await formDataRequest('banners/delete', params);
}
export async function serviceGetBanners(params) {
    return await postRequest('banners', params);
}
